import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@chikara/ui';
import { PageContent } from '@/shared/components/PageContent';
import { useCardBatches } from '@/features/card/hooks/useCard/useCardBatches';
import { useConfirmBatch } from '@/features/card/hooks/useCard/useConfirmBatch';
import styles from './CardTrackingPage.module.css';
import { t } from '@/i18n';
import * as ROUTER from '@/shared/constants/routes';


export const CardTrackingPage = () => {
    const navigate = useNavigate();
    const { suitcase_uuid } = useParams();

    const { batchDetail, fetchBatchDetail } = useCardBatches();
    const { confirmBatch } = useConfirmBatch();

    const breadcrumbItems = [
        { label: t('dashboard.card.detail.breadcrumb'), onClick: () => navigate(ROUTER.CARD) },
        { label: t('dashboard.card.actions.tracking') },
    ];

    const handleConfirm = async () => {
        if (suitcase_uuid) {
            await confirmBatch(suitcase_uuid);
            navigate(ROUTER.CARD, { state: { tab: 'traking' } });
        }
    };

    useEffect(() => {
        if (!suitcase_uuid) return;
        fetchBatchDetail(suitcase_uuid);
    }, [suitcase_uuid]);

    return (
        <PageContent
            breadcrumb={breadcrumbItems}
            title={`${t('dashboard.card.actions.tracking')}`}
            onBack={() => navigate(ROUTER.CARD, { state: { tab: 'traking' } })}
        >
            <div className={styles.container}>
                <div className={styles.card}>
                    <h2 className={styles.sectionTitle}>{t('dashboard.card.trackingDetail.title')}</h2>

                    <div className={styles.infoGrid}>
                        <div className={styles.infoBox}>
                            <div className={styles.label}>{t('dashboard.card.trackingDetail.info.requestDate')}</div>
                            <div className={styles.value}>{batchDetail?.cdate}</div>
                        </div>
                        <div className={styles.infoBox}>
                            <div className={styles.label}>{t('dashboard.card.trackingDetail.info.quantity')}</div>
                            <div className={styles.value}>{batchDetail?.request_number}</div>
                        </div>
                        <div className={styles.infoBox}>
                            <div className={styles.label}>{t('dashboard.card.trackingDetail.info.estDelivery')}</div>
                            <div className={styles.value}>{batchDetail?.estimatedDeliveryTime} días</div>
                        </div>
                    </div>

                    <div className={styles.addressBox}>
                        <div className={styles.addressTitle}>{t('dashboard.card.trackingDetail.address.title')}</div>
                        <div className={styles.addressLines}>
                            <div>{t('dashboard.card.trackingDetail.address.lines.zipCode')}: {batchDetail?.tracking?.shipment?.zip}</div>
                            <div>{t('dashboard.card.trackingDetail.address.lines.city')}: {batchDetail?.tracking?.shipment?.state}</div>
                            <div>{t('dashboard.card.trackingDetail.address.lines.municipality')}: {batchDetail?.tracking?.shipment?.locality}</div>
                            <div>{t('dashboard.card.trackingDetail.address.lines.colony')}: {batchDetail?.tracking?.shipment?.town}</div>
                            <div>{t('dashboard.card.trackingDetail.address.lines.street')}: {batchDetail?.tracking?.shipment?.street}</div>
                            <div>{t('dashboard.card.trackingDetail.address.lines.exteriorNumber')}: {batchDetail?.tracking?.shipment?.ext_num}</div>
                            {batchDetail?.tracking?.shipment?.int_num && (
                                <div>{t('dashboard.card.trackingDetail.address.lines.interiorNumber')}: {batchDetail?.tracking?.shipment?.int_num}</div>
                            )}
                        </div>
                    </div>

                    {batchDetail?.status !== 'received' && (
                        <div className={styles.actions}>
                            <Button
                                variant="primary"
                                onClick={handleConfirm}
                            >
                                {t('dashboard.card.trackingDetail.actions.confirm')}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </PageContent>
    );
};

export default CardTrackingPage;
